const comMain = (() => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let secMain = document.querySelector('#jsComSecMain');
    let mainWrap = secMain.querySelector('.js-main-wrap');

    setTimeout(() => {
      mainWrap.classList.add('is-act');
    }, 500);



  }
})()
export default comMain;